import { callAPI } from '../network';

export async function updateZonesByEmployee (zones, employee ){

    //console.log(zones);
    const params = {
       zones: zones.zones.map(zone => ({
          Id: zone.Id, // Asegúrate de usar la capitalización correcta, como aparece en el objeto.
          Code: zone.Code // Igualmente aquí.
        })),
        employeeId: zones.employeeId,
        employee: employee
     };
 
    
    const data = await callAPI(
                   params, 
                         'Zone/UpserZoneEmployee', 'post');
    return data || [ ];
 }


 export async function getEmployeesWithZones (companyId){
  
    const data = await callAPI(
                         null, 
                         'Zone/getEmployeesWithZones?companyId=' + companyId, 'get');
    return data || [ ];
 }

 export async function getAllZonesByEmployee(employeeId){
    let data;
       data = await callAPI(
          null, 
          'Zone/GetZoneByEmployee?EmployeeId='+ employeeId, 'get');
    
   
    return data || [ ];
 }

 
export async function GetAllEmployeesByZone(id){

   const data = await callAPI(
                        null, 
                        'Zone/GetAllEmployeesWithZonesByZone?AirportID=' + id, 'get');
   return data;
}

export async function deleteZonesByEmployee (id, employee){
   const data = await callAPI(
                        null, 
                        `Zone/DeleteZoneEmployee?employeeId=${id}&employee=${employee}`, 'get');
   return data;
}


export async function GetAllEmployeesWithZonesByZone(id, companyId){
   const url = id
      ? `Zone/GetAllEmployeesWithZonesByZone?companyId=${companyId}&ZoneID=${id}`
      : `Zone/GetAllEmployeesWithZonesByZone?companyId=${companyId}`;
   const data = await callAPI(null, url, 'get');
   return data;
}

export async function GetAllEmployeesByAirport(id, companyId){
   const url = id
      ? `Zone/GetallemployeesByAirportForEdit?companyId=${companyId}&ZoneID=${id}`
      : `Zone/GetallemployeesByAirportForEdit?companyId=${companyId}`;
   const data = await callAPI(null, url, 'get');
   return data;
}

export async function bulkUpserZoneEmployee(employeeIds, zones, employee) {
   const params = { employeeIds, zones, employee };
   const data = await callAPI(params, 'Zone/BulkUpserZoneEmployee', 'post');
   return data;
}